<template>
	<mn-form-table v-model="list" :addTemplate="addTemplate" drag-sort placeholder="暂无数据">
        <el-table-column prop="key" label="键名">
            <template #default="scope">
                <el-input v-model="scope.row.key" placeholder="请输入内容"></el-input>
            </template>
        </el-table-column>
        <el-table-column prop="value" label="键值">
            <template #default="scope">
                <el-input v-model="scope.row.value" placeholder="请输入内容"></el-input>
            </template>
        </el-table-column>
    </mn-form-table>
</template>

<script>
	export default {
		props: {
			modelValue: {
				type: Array,
				default: ()=>{
                    return []
                }
			},
            isAdd:{
                type:Boolean,
                default:true
            }
		},
		data() {
			return {   
                visible:false,
                formlist:[
                   
                ],
				addTemplate: {
					key:'',
                    value:''
				},
                list: []
			}
		},
        watch:{
			list:{
                handler(){
				    this.$emit('update:modelValue', this.list)
                },
				deep: true
			}
		},
		mounted() {
            this.$nextTick(()=>{
                this.list = this.modelValue
            })
		},
		methods: {
			submit(){
                this.$refs.dialogForm.validate(async (valid) => {
					if (valid) {
						console.log(valid);
					}
				})
            }
		}
	}
</script>

<style scoped lang="scss">
.el-form-item .el-form-item{
    margin-bottom: 18px;
}
.header{
    width: 100%;
    display: flex;
    justify-content: space-between;
    .icon{
        display: none;
    }
}
.header:hover{
    .icon{
        display: block;
    }
}
</style>
